/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {
    Timeline,
    TimelineLite
} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";
import {HarlequinBackground} from "../background/HarlequinBackground";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";
import {HarlequinSpinReelController} from "../spinreel/HarlequinSpinReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";

export class SpinStart implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;
    private _nextMode:string;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    prepare(data:HarlequinParsedGameData) {
        this.stagger = ((data.mode === "NORMAL" || data.mode === "FREESPIN") && (data.nextMode === "WILD_RESPIN" || data.nextMode === "WILD_RESPIN_FS"))? 1 : 0;
        this._nextMode = data.nextMode;
    }

    public getAnimation(data:ParsedServerData):Timeline | null {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => {
            HarlequinGameModuleConfig.plusOneView.resetPlusOneSpines();
            HarlequinGameModuleConfig.nearWinView.hideWildOmens();
            HarlequinGameModuleConfig.betLinesView.killBetlines();
        });
        return tl;
    }
}